module.exports = __webpack_public_path__ + "static/media/portfolio1.723955ea.png";